import { useState, useEffect } from "react";
// --------------------- Import Services ---------------------
import { buscarAptosByEmpreendService } from "../../../services/buscarAptosByEmpreend";
import { Apartamento } from "../../../interfaces/Apartamento";

export const useBuscarAptoEmpreend = (
  isModalOpen: boolean,
  empreendId: number
) => {
  const [aptos, setAptos] = useState<Apartamento[]>([]); // ideal tipar
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const buscar = async () => {
    setError(null);
    if (isModalOpen) {
      try {
        setIsLoading(true);
        const data = await buscarAptosByEmpreendService(empreendId);
        setAptos(data);
      } catch (err) {
        setError("Erro ao buscar apartamentos");
      } finally {
        setIsLoading(false);
      }
    }
  };

  useEffect(() => {
    buscar();
  }, [isModalOpen, empreendId]);

  return { aptos, isLoading, error };
};
